import { type KomboApplicationStage as KomboJobStageResponse } from "../api";
import { Utility } from "./utility";

export interface KomboApplicationStage extends KomboJobStageResponse {}

export class KomboApplicationStage extends Utility<KomboApplicationStage> {
  constructor(init?: Partial<KomboJobStageResponse>) {
    super();
    Object.assign(this, init);
  }
}
